import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  useToast,
  Spinner,
} from "@chakra-ui/react";

import { Lock } from "@mui/icons-material";
import { Fade } from "react-reveal";
import qr from "../assets/qr.jpg";
// import trust from "../assets/TRUST.PNG";
import trust from "../assets/Yinks.JPG";

console.log();
export default function QRmodal({ isOpen, onClose }) {
  const toast = useToast();

  return (
    <div>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent style={{ marginTop: "230px", width: "97%" }}>
          <ModalBody className="mb-3">
            <center>
              <div className=" pb-2 ">
                <h5>
                  USDT ADDRESS (<b>TRC20</b>){" "}
                </h5>
                <p style={{ color: "blue", fontSize: "13px", padding: "10px" }}>
                  Send only Tether (TRC20) to this address. Sending any other
                  coins may results in permanent loss.
                </p>
                <br />
                <img src={trust} alt="..." className="modalImg " />
              </div>
              <br />
            </center>
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  );
}
